module.exports = __webpack_public_path__ + "img/logo6.d51a0d52.png";